import { Component, OnInit, ViewChild, Directive } from '@angular/core';
import { GroupDescriptor, State, process, CompositeFilterDescriptor, FilterDescriptor } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent, FilterService } from '@progress/kendo-angular-grid';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { FlowManagementService, flatten } from '../services/flow-management.service';

@Directive()
export class PowerBaseComponent implements OnInit {

  constructor(
    protected apiService: FlowManagementService,
    protected sanitizer: DomSanitizer
  ) {

  }

  public ready = true;
  public items: any[] = [];

  public groups: GroupDescriptor[] = [/*{ field: 'ownerName' }*/];

  public state: State = {
    skip: 0,
    take: 50, //this.flows.length,

    // Initial filter descriptor
    filter: {
        logic: 'and',
        filters: [] //[{ field: 'ProductName', operator: 'contains', value: 'Chef' }]
    },
    sort: [
        // {
        //     'field': 'displayName',
        //     'dir': 'asc'
        // }
    ],
    group: this.groups
  };
  public view: GridDataResult = process(this.items, this.state);

  @ViewChild('grid', {static: true})
  public grid;


  ngOnInit() {
    // this.ready = false;
    // this.apiService.getEvents().then(events => {
    //   this.items = events;

    //   this.updateView();
    //   this.ready = true;
    // });
  }

  public dataStateChange(state: DataStateChangeEvent): void {

    // debugger
    if (state.sort && state.sort.length == 1) {
        // only on 1

        var field = state.sort[0].field;

        if (this.state.sort.length > 0 && field !=  this.state.sort[0].field) {

            var desc = this.grid.columns.filter(function(c){return c.field == field && (c.filter == "date" || c.filter == "number"); }).length > 0;

            if (desc) {
                state.sort[0].dir = "desc";
            }
        }
    }

    this.state = state;
    this.updateView();
  }

  public multiChange(values: any[], filterService: FilterService, field: string, operator: string): void {
    filterService.filter({
        filters: values.map(value => ({
            field: field,
            operator: operator,
            value
        })),
        logic: 'or'
    });
  }

  public multiFilters(filter: CompositeFilterDescriptor): FilterDescriptor[] {
      return flatten(filter).map(({ value }) => value);
  }

  public groupChange(groups: GroupDescriptor[]): void {
    this.groups = groups;
    this.state.group = this.groups;
    this.updateView();
  }

  public updateView() {
    //debugger
    this.view = process(this.items, this.state);
  }

  public getSafeUrl(url): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

}
